

























import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";
import { IHandover } from "@/models/handover.entity";
import { HandoverStateEnum } from "@/lib/enum/handover-state.enum";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefsHandover extends Vue implements IRefDetail<IHandover> {
  @Prop()
  item!: IHandover;

  @Prop({ default: false })
  small!: boolean;

  confirmable = false;

  goToDetail(openInNew = true) {
    new GoToHelper(this.$router).goToHandoverDetail(this.item.id, this.item.partnerId, openInNew);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  get HandoverStateEnum() {
    return HandoverStateEnum;
  }

  get names() {
    const names = [];

    for (const attendee of this.item.attendees) {
      names.push(attendee.email);
    }

    return names;
  }

  get companies() {
    const names = [];

    for (const company of this.item.parties) {
      if (company?.companyName) {
        names.push(company.companyName);
      }
    }

    return names;
  }
}
